module.exports = __webpack_public_path__ + "img/airport_slide5.44196dd4.png";